// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable plugin/no-unused-selectors */
/* stylelint-disable no-descending-specificity */
.KWQlnMvysRK4fI {
  position: relative;
  min-height: 36px;
  border-radius: 8px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: 8px;
}
.KWQlnMvysRK4fI:focus-within {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
  opacity: 1;
}
.mac .KWQlnMvysRK4fI:focus-within {
  outline-color: -webkit-focus-ring-color;
}
.KWQlnMvysRK4fI:focus-within .mac.firefox {
  outline-color: AccentColor;
}
.safari .KWQlnMvysRK4fI:focus-within {
  outline-style: solid;
}
.KWQlnMvysRK4fI:has([data-testid='card-front-board-hint']) {
  margin-bottom: 5px;
}
.KWQlnMvysRK4fI.dI6tb3dkfNCbeM {
  background-color: var(--ds-background-information, #e9f2ff);
}
.g7tgephqvA8RIv:not(:hover, :focus-within, [data-drag-preview]) {
  background-color: transparent;
  box-shadow: none;
}
.HdmdMX645LvWS7 {
  display: none;
  position: absolute;
  z-index: 10;
  top: 2px;
  right: 2px;
  /* stylelint-disable-next-line selector-max-type */
}
.KWQlnMvysRK4fI:hover .HdmdMX645LvWS7,
.hFJaqciuWeVPkc {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.KWQlnMvysRK4fI[data-drag-preview] .HdmdMX645LvWS7 {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
@media (prefers-reduced-motion: reduce) {
  .xY6NBEQos8kXPJ .vOxQSuhNW_rXz1 {
    transition: none;
    opacity: 1;
  }
  .xY6NBEQos8kXPJ .hAJCJsXpkOWoCC {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: none;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .xY6NBEQos8kXPJ .vOxQSuhNW_rXz1 {
    transition: opacity 0.3s ease-in;
    opacity: 0;
  }
  .xY6NBEQos8kXPJ .vOxQSuhNW_rXz1:focus-visible {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
  .xY6NBEQos8kXPJ .hAJCJsXpkOWoCC {
    width: 100%;
    transform: translateX(-20px);
    transition: all 0.3s ease-in;
  }
  .KWQlnMvysRK4fI:hover .xY6NBEQos8kXPJ .vOxQSuhNW_rXz1,
  .KWQlnMvysRK4fI:focus-within .xY6NBEQos8kXPJ .vOxQSuhNW_rXz1,
  .gGtN7RssmzKkba .vOxQSuhNW_rXz1 {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
  .KWQlnMvysRK4fI:hover .xY6NBEQos8kXPJ .hAJCJsXpkOWoCC,
  .KWQlnMvysRK4fI:focus-within .xY6NBEQos8kXPJ .hAJCJsXpkOWoCC,
  .gGtN7RssmzKkba .hAJCJsXpkOWoCC {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: transform 0.3s ease-in;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFront": `KWQlnMvysRK4fI`,
	"pinned": `dI6tb3dkfNCbeM`,
	"cardFront--separator": `g7tgephqvA8RIv`,
	"cardFrontActions": `HdmdMX645LvWS7`,
	"cardFrontActions--isCardActive": `hFJaqciuWeVPkc`,
	"cardFrontAnimateDoneState": `xY6NBEQos8kXPJ`,
	"buttonAnimation": `vOxQSuhNW_rXz1`,
	"cardTitleAnimation": `hAJCJsXpkOWoCC`,
	"cardFrontAnimateDoneState--isCardActive": `gGtN7RssmzKkba`
};
export default ___CSS_LOADER_EXPORT___;
